import React, { useEffect, useState } from "react";
import { Card, Col, Modal, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import Baseurl from "../../../Baseurl";
function ViewExperts(props) {
  const [riderListData, setRiderListData] = useState([]);

  const [viewimage, setViewImage] = useState();
  const [review, setReview] = useState("");
  const [reason, setReason] = useState("");
  const [rating, setRating] = useState("");

  const [show1, setShow1] = useState(false);
  const [show, setShow] = useState(false);
  const [ownerDetails, setOwnerDetails] = useState([]);

  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [acceptStatus, setAcceptStatus] = useState(false);
  const { id, val } = props.match.params;
  var history = useHistory();
  const handleClose1 = () => {
    setShow1(false);
  };

  function getData() {
    let listData = [];
    listData = [
      {
        title: "Name",
        data: props.location.state.Name,
      },
      {
        title: "Company Name",
        data: props.location.state.CompanyName,
      },
      {
        title: "Company Pincode",
        data: props.location.state.CompanyPincode,
      },

      {
        title: "Contact No",
        data: props.location.state.Phone,
      },
      {
        title: "Address",
        data: props.location.state.CompanyAddress,
      },
      {
        title: "Adharcard Number",
        data: props.location.state.AadhaarNumber,
      },
      {
        title: "Experience Year",
        data: props.location.state.ExperienceYear,
      },
      {
        title: "Experience Month",
        data: props.location.state.ExperienceMonth,
      },
      {
        title: "Company Gst",
        data: props.location.state.CompanyGst,
      },
    ];
    console.log("list data", listData);
    setRiderListData(listData);
  }
  useEffect(() => {
    getData();
  }, []);

  const accept = () => {
    const params = {
      oId: props.location.state._id,
      cName: props.location.state.CompanyName,
      cCategory: props.location.state.Categories[0],
      rating: rating,
      review: review,
      uId: "Admin",
      approved: true,
    };
    axios
      .put(
        `${Baseurl.baseurl5}/go-home-service/home-service-owner/approve-reject-home-experts`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Accepted", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          history.push("/Experts-List");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }

        handleClose1();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  };
  function viewImage(img) {
    setShow1(true);
    setViewImage(img);
    setAcceptStatus(false);
  }
  function rejectExperts() {
    const params = {
      oId: props.location.state._id,
      cName: props.location.state.CompanyName,
      cCategory: props.location.state.Categories[0],
      rating: "",
      review: "",
      uId: "Admin",
      approved: false,
      rejectedReason: "",
    };
    axios
      .put(
        `${Baseurl.baseurl5}/go-home-service/home-service-owner/approve-reject-home-experts`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Rejected", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          history.push("/Experts-List");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }

        handleClose1();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <Col xl="12">
      <Modal size="lg" show={show} onHide={()=>{setShow(false)}}>
        <Modal.Body>
          <div className="row">
            <div className="col-sm-2 mt-2">
              <label>Reason</label>
            </div>
            <div className="col-sm-4 ">
              <textarea
                type="text"
                className="form-control"
                id="val-username"
                name="val-username"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter reject reason"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              rejectExperts();
            }}
            className="btn btn-danger"
          >
            Reject
          </button>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show1} onHide={handleClose1}>
        <Modal.Body>
          <div>
            {acceptStatus ? (
              <div className="row">
                <div className="col-sm-2 mt-2">
                  <label>Rating</label>
                </div>
                <div className="col-sm-4 ">
                  <input
                    type="number"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={rating}
                    onChange={(e) => {
                      if (e.target.value.length < 2 && e.target.value < 6) {
                        setRating(e.target.value);
                      }
                    }}
                    placeholder="Enter rating 0-5"
                  />
                </div>
                <div className="col-sm-2 mt-2">
                  <label>Review</label>
                </div>
                <div className="col-sm-4 ">
                  <textarea
                    type="text"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={review}
                    onChange={(e) => setReview(e.target.value)}
                    placeholder="Enter Review"
                  />
                </div>
              </div>
            ) : (
              <img
                alt=""
                style={{
                  resizeMode: "cover",
                  width: "100%",
                  height: "100%",
                }}
                className="playerProfilePic_home_tile"
                src={viewimage}
              />
            )}
          </div>
        </Modal.Body>
        {acceptStatus && (
          <Modal.Footer>
            <button
              onClick={() => {
                setSpinnerAccept(true);
                accept();
              }}
              className="btn btn-primary"
            >
              Accept
            </button>
          </Modal.Footer>
        )}
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <Card.Title className="text-white">Rider Details</Card.Title>
          <button
            className="btn btn-primary"
            onClick={() => {
              history.goBack();
            }}
          >
            Back
          </button>
        </Card.Header>
        <Card.Body>
          <Card.Text>
            <div className="profile-personal-info ">
              {riderListData &&
                riderListData.map((val) => {
                  return (
                    <>
                      {val.data && (
                        <div className="row mb-2 ">
                          <div className="col-3 mt-1">
                            <h5 className="f-w-500 text-white ">
                              {val.title}
                              <span className="pull-right">:</span>
                            </h5>
                          </div>
                          <div className="col-9">
                            <span>{val.data} </span>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })}
              <div className="row mb-2 ">
                <div className="col-3 mt-1">
                  <h5 className="f-w-500 text-white ">
                    Categories
                    <span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-9">
                  {props.location.state.Categories.map((val) => {
                    return (
                      <span>
                        {val}
                        <br />{" "}
                      </span>
                    );
                  })}
                </div>
              </div>
              <div className="row mb-2 mt-3">
                <div className="col-3 mt-5">
                  <h5 className="f-w-500 text-white">
                    Adhar Images
                    <span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-sm-9">
                  <div className="row">
                    {props.location.state.AadhaarImages &&
                      props.location.state.AadhaarImages.map(
                        (payload, index) => {
                          return (
                            <div
                              onClick={() => {
                                viewImage(payload);
                              }}
                              className="col-sm-4"
                              style={{
                                marginTop: "5px",
                                width: 180,
                                height: 100,
                                aspectRatio: 1 * 1.4,
                              }}
                            >
                              <img
                                alt=""
                                src={payload}
                                style={{
                                  resizeMode: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                              />
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
              <div className="row mb-2 mt-3">
                <div className="col-3 mt-5">
                  <h5 className="f-w-500 text-white">
                    Company Images
                    <span className="pull-right">:</span>
                  </h5>
                </div>
                <div className="col-sm-9">
                  <div className="row">
                    {props.location.state.Images &&
                      props.location.state.Images.map((payload, index) => {
                        return (
                          <div
                            onClick={() => {
                              viewImage(payload);
                            }}
                            className="col-sm-4"
                            style={{
                              marginTop: "5px",
                              width: 180,
                              height: 100,
                              aspectRatio: 1 * 1.4,
                            }}
                          >
                            <img
                              alt=""
                              src={payload}
                              style={{
                                resizeMode: "cover",
                                width: "100%",
                                height: "100%",
                              }}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </Card.Text>
        </Card.Body>
        {!props.location.state.Approved && (
          <Card.Footer className=" d-sm-flex justify-content-between align-items-center">
            <button
              className="btn btn-danger"
              onClick={(e) => {
                setShow(true)
               
              }}
            >
              Reject
            </button>
            <button
                className="btn btn-primary ml-auto mr-2"
                onClick={(e) => {
                 setAcceptStatus(true)
                  setShow1(true);
                }}
              >
                Accept
              </button>
          </Card.Footer>
        )}
      </Card>
    </Col>
  );
}

export default ViewExperts;
